import { render, staticRenderFns } from "./chevron-left.vue?vue&type=template&id=1e3cd3a4&"
import script from "./chevron-left.vue?vue&type=script&lang=js&"
export * from "./chevron-left.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/events/components/icons/chevron-left.vue
// module id = 1163
// module chunks = 0